import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class SubCategoryService {
  async getAllSubCategories({ search, limit, page, orderBy, order, category, Status }) {
    return (
      await fetchApi.get(
        `${URL}/subcategory/list?limit=${limit}&page=${page}&orderBy=${orderBy}&order=${order}&category=${category}&Status=${Status}${search ? `&search=${encodeURIComponent(search)}` : ""
        }`
      )
    ).data;
  }

  async getAllCategories() {
    return (await fetchApi.get(`${URL}/subcategory/categorylist`)).data;
  }

  async getSubCategoryById(id) {
    return (await fetchApi.get(`${URL}/subcategory/${id}`)).data;
  }

  async createSubCategory(formData) {
    return (await fetchApi.post(`${URL}/subcategory`, formData)).data;
  }

  async updateSubCategory(id, formData) {
    return (await fetchApi.patch(`${URL}/subcategory/${id}`, formData)).data;
  }

  async deleteSubCategory(id) {
    return (await fetchApi.delete(`${URL}/subcategory/${id}`)).data;
  }
}
